import React from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { NumberPatternEditor } from '../../components/admin/NumberPatternEditor';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { Hash } from 'lucide-react';

export const NumberPatternsPage: React.FC = () => {
  const { numberPatterns, isLoading, updateNumberPattern } = useAdminConfig();

  if (isLoading) return <LoadingSpinner size="lg" text="Loading Number Patterns..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <Hash className="w-5 h-5 text-sky-400" />
          Number Format Patterns
        </h3>
        <p className="text-xs text-slate-400">Configure ID generation patterns for entities</p>
      </div>

      <Card title="ID Generation Patterns">
        <NumberPatternEditor
          patterns={numberPatterns}
          onUpdate={updateNumberPattern}
        />
      </Card>
    </div>
  );
};
